const isLocal = window.location.href.includes("localhost");

export const Constants = {
    isCheckCaptcha: !isLocal,
    IPGEOLOCATION_API_KEY: '7181cf9967944127b0e49d83851565c0',
    RECAPTCHA_SITE_KEY: '6LeKq6wsAAAAAHGVCD5hP2vEX2XJqHpuRqvJdFlJ', // v3
    RECAPTCHA_V2_SITE_KEY: '6LdptBYqAAAAAB5jpM5AjQUzcODXjD9fe3UxjzIj', // v2
    BACKEND_URL: 'https://api.loanmantra.com',
    TOASTERHIDETIME: 4000,
    CRYPTO_SECRET_KEY: 'ba3be1d6cdc455d085fabeafa3b5f12c',
    DOMAIN_SUFFIX: '',
    DEFAULT_DOMAIN_NAME: 'loanmantra.com',
    SESSION_TIMEOUT: 30 * 60 * 1000 // 30 minutes
}

export const limitDurationOptions = [
    { value: 0, label: 'Yearly' },
    { value: 1, label: 'Monthly' },
];
 
export const unlimitedLimitedOptions = [
    { value: 0, label: 'Unlimited' },
    { value: 1, label: 'Limited' },
];